import cacheAngularTemplate from 'cacheAngularTemplate';
import moment from 'moment-timezone';
import { MAX_APPLICANT_AGE, MIN_APPLICANT_AGE } from 'FormConfigs';
import angularModule from '../careers_module';
import template from '../../views/edit_career_profile/basic_info_form.html';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('basicInfoForm', [
    '$injector',
    function factory($injector) {
        const FormHelper = $injector.get('FormHelper');
        const EditCareerProfileHelper = $injector.get('EditCareerProfileHelper');
        const dateHelper = $injector.get('dateHelper');
        const TranslationHelper = $injector.get('TranslationHelper');

        return {
            restrict: 'E',
            // see STEP_FORM_ATTRS in edit_career_profile_dir.js
            scope: {
                // form-step-validity reads this by name off the scope. See STEP_FORM_ATTRS.
                $setValidity: '<setValidity',
                careerProfile: '<',
                formContext: '<',
                disableSubstantialApplicationEdits: '<',
                transientFormValues: '<',
            },
            templateUrl,
            link(scope) {
                scope.dateHelper = dateHelper;

                // FIXME: account for EMBA as well
                EditCareerProfileHelper.logEventForApplication(scope.formContext, 'viewed-basic_info');

                scope.recentRolesOptions = EditCareerProfileHelper.recentRolesOptions(scope.careerProfile);
                scope.highestLevelEducationOptions = EditCareerProfileHelper.highestLevelEducationOptions();
                scope.yearsExperienceOptions = EditCareerProfileHelper.yearsExperienceOptions(scope.careerProfile);

                FormHelper.supportForm(scope, scope.basic_info);

                scope.minBirthday = moment().subtract(MAX_APPLICANT_AGE, 'years').format('YYYYMMDD');
                scope.maxBirthday = moment().subtract(MIN_APPLICANT_AGE, 'years').format('YYYYMMDD');
                scope.proxy = {};

                // Publish the two inputs on this form that the validation schema needs but that
                // neither model stores. See transientFormValues in edit_career_profile_dir.js and the
                // basic_info schema in FormConfigs.
                scope.$watch('sexPlaceholder', sexPlaceholder => {
                    scope.transientFormValues.sex_selection = sexPlaceholder;
                });

                scope.$watch('proxy.locationViewValue', locationViewValue => {
                    scope.transientFormValues.location_view_value = locationViewValue;
                });

                scope.$watch('proxy.birthdateViewValue', () => {
                    if (scope.proxy.birthdateViewValue) {
                        scope.invalidAge =
                            scope.proxy.birthdateViewValue < scope.minBirthday ||
                            scope.proxy.birthdateViewValue > scope.maxBirthday
                                ? moment().diff(scope.proxy.birthdateViewValue, 'years')
                                : undefined;
                    } else {
                        scope.invalidAge = undefined;
                    }

                    scope.showInvalidAge = angular.isDefined(scope.invalidAge);
                });

                scope.$on('beforeSaveForm', () => {
                    if (!scope.careerProfile.legal_names.includes(scope.careerProfile.name)) {
                        scope.careerProfile.legal_names.push(scope.careerProfile.name);
                    }
                });

                const fieldOptionsTranslationHelper = new TranslationHelper('careers.field_options');
                const demoGraphicsTranslationHelper = new TranslationHelper(
                    'careers.edit_career_profile.demographics_form_section',
                );

                scope.genderPlaceHolder = demoGraphicsTranslationHelper.get('gender');

                scope.sexOptions = ['male', 'female', 'non_binary', 'self_describe', 'no_identify'].map(
                    translationKey => ({
                        value: translationKey,
                        label: fieldOptionsTranslationHelper.get(translationKey),
                    }),
                );

                scope.sexPlaceholder = scope.careerProfile?.sex
                    ? ['male', 'female', 'non_binary', 'no_identify'].find(v => v === scope.careerProfile.sex) ||
                      'self_describe'
                    : null;

                scope.isSelfDescribedSex = scope.sexPlaceholder === 'self_describe';

                scope.$watch('sexPlaceholder', (newVal, oldVal) => {
                    if (newVal === oldVal) return;

                    if (newVal === 'self_describe') {
                        scope.careerProfile.sex = null;
                        scope.isSelfDescribedSex = true;
                        return;
                    }

                    scope.isSelfDescribedSex = false;
                    scope.careerProfile.sex = newVal;
                });

                scope.$watch('careerProfile.sex', val => {
                    if (!val) scope.careerProfile.sex = null;
                });
            },
        };
    },
]);
